import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { Highlight } from './highlight.model';

export const GLOBAL_SEARCH_RESULTS_SCHEMA = Object.freeze({
  TOTAL_MATCHES: 0,
  RESULTS: List<any>(),
  HIGHLIGHTS: List<Highlight>(),
});
const RECORD = generateSchema(GLOBAL_SEARCH_RESULTS_SCHEMA);
const KEYS: any = generateKeys(GLOBAL_SEARCH_RESULTS_SCHEMA);

export class GlobalSearchResults extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.HIGHLIGHTS,
        value: this.get(KEYS.HIGHLIGHTS)
          ? this.highlights.map((params) => new Highlight(params))
          : List<Highlight>([]),
      },
    ]);

    return selfModel as GlobalSearchResults;
  }

  get totalMatches(): number {
    return this.get(KEYS.TOTAL_MATCHES);
  }

  get results(): List<any> {
    return this.get(KEYS.RESULTS);
  }

  get highlights(): List<Highlight> {
    return this.get(KEYS.HIGHLIGHTS);
  }
}
